import { Firm, MPID } from 'api/interfaces/firm';
import { PrismApplication } from 'api/interfaces/prismApplication';
import { isBusinessUnitsEnabled } from 'config/features';
import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'redux/applicationState';
import { applicationsListSelector } from 'redux/reducers/referenceDataReducer';
import classes from 'routes/EntityManagement/FirmsManagement/components/FirmsForm/components/MPIDItem/MPIDItem.module.scss';

interface Props {
  readonly mpid: MPID;
}

export const MPIDItem: React.FC<Props> = (props: Props): React.ReactElement => {
  const { mpid } = props;
  const applications = useSelector(applicationsListSelector);
  const { firmsById } = useSelector((state: ApplicationState) => state.firms);

  const applicationName = React.useMemo((): string => {
    const found = applications.find((application: PrismApplication): boolean => {
      return application.app_id === mpid.appid;
    });

    return found?.app_name ?? 'Unknwon Application';
  }, [applications, mpid.appid]);

  const businessUnitName = React.useMemo((): string => {
    if (!isBusinessUnitsEnabled) {
      return '';
    }

    const found = firmsById.some((firm: Firm): boolean => {
      return firm?.BU?.includes(mpid.appid);
    });
    return found ? `Business Unit: ${mpid.appid}` : '';
  }, [firmsById, mpid.appid]);

  return (
    <div className={classes.container}>
      <div className={classes.mpid}>{mpid.mpid}</div>
      <div className={classes.applicationName}>
        {businessUnitName ? businessUnitName : applicationName}
      </div>
    </div>
  );
};
